import React, { CSSProperties, useState } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import "./Help.scss";

type HelpProps = {
  title: string;
  text: string;
  maxWidth?: string;
};

const Help = ({ title, text, maxWidth }: HelpProps) => {
  const [open, setOpen] = useState(false);
  const dialogBoxStyle: CSSProperties = maxWidth ? { maxWidth } : {};

  const dialog = (
    <div className="dialog-overlay" onClick={() => setOpen(false)}>
      <div className="dialog-box"  style={dialogBoxStyle} onClick={(e) => e.stopPropagation()}>
        <button
          className="dialog-close"
          type="button"
          onClick={() => setOpen(false)}
          aria-label="Close dialog"
        >
          ✕
        </button>
        <h2><b>{title}</b></h2>
        <p dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="icon-button"
        type="button"
        aria-label="Open dialog"
      >
        <FontAwesomeIcon icon={faInfoCircle} size="lg" />
      </button>

      {open && createPortal(dialog, document.body)}
    </>
  );
};

export default Help;
